import { AiType, AiTypeLabel, UserLevel } from '@/interface/aigc';

const CONTACT_EMAIL = '3102714110@qq.com';

// 根据资源和用户类型，获取使用超额提示信息
export const getUsageExceedMessage = (type: AiType, user?: UserLevel) => {
  if (user === undefined) return;

  switch (user) {
    case UserLevel.FREE:
      return {
        title: `今日 ${AiTypeLabel[type]} 额度已用完`,
        desc: `今天的 ${AiTypeLabel[type]} 次数已达上限，次日0点将自动恢复使用次数，或联系官方邮箱 ${CONTACT_EMAIL} 申请获取更多创作次数。`,
      };
    case UserLevel.SIGNED:
    case UserLevel.VIP:
      return {
        title: `今日 ${AiTypeLabel[type]} 额度已用完`,
        desc: `今天的 ${AiTypeLabel[type]} 次数已达上限，次日0点将自动恢复使用次数，可联系官方运营人员或联系官方邮箱 ${CONTACT_EMAIL} 申请获取更多创作次数。`,
      };
    case UserLevel.BLACK:
      return {
        title: '账户状态异常',
        desc: `检测到您的账户存在异常活动，为保护您的权益已暂时限制使用。请联系官方邮箱 ${CONTACT_EMAIL} 申请恢复，我们将协助您尽快解决。`,
      };
    default:
      return;
  }
};
